import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'
import { TextField, Divider, Select, MenuItem } from '@mui/material'

const FormDivider = styled(Divider)`
  border-color: grey !important;
  color: grey;
  font-size: ${fontSize('sm')};
  margin: ${size(1)};

  &::before {
    border-color: grey !important;
  }
  &::after {
    border-color: grey !important;
  }
`

const InputLabel = styled.label`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`

const LabelText = styled.span`
  padding: 0 0 ${size(0.5)} ${size(1)};
  font-size: ${fontSize('sm')};
`

const StyledTextField = styled(TextField)`
  width: 100%;
  margin-bottom: ${size(2)};

  & textarea {
    color: white !important;
  }

  & label {
    color: white !important;
  }
  
  & .MuiOutlinedInput-root {
    color: white !important;

    & fieldset {
      border-color: grey !important;
      border-radius: 15px;
    }
  }
`

const OptionWrapper = styled.div`
  display: flex !important;
  align-items: center !important;
  padding-right: 0;
  font-weight: 500;
`

const StyledSelect = ({ wrapperStyles, children, ...rest }) => {
  return (
    <Select
      sx={{
        '.MuiSelect-select': {
          paddingLeft: `16px !important`,
          paddingRight: `16px !important`,
          paddingTop: '0 !important',
          paddingBottom: '0 !important',
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '.MuiSvgIcon-root ': {
          color: 'grey',
        },
        borderRadius: '15px',
        // backgroundColor: 'rgba(20,20,20,0.9)',
        color: 'white',
        border: '1px solid grey',
        height: size(5),
        marginBottom: size(2),
        fontSize: fontSize('sm'),
        ...wrapperStyles,
      }}
      {...rest}>
      {children}
    </Select>
  )
}

const FormSelect = ({ label, options=[], emptyOptionText='None', displayEmpty=true, ...rest }) => {

  // WARNING: You can't abstract the below MenuItem into its own component due to weirdness with mui select internals
  //          https://stackoverflow.com/questions/68378474/mui-select-custom-menuitem-not-working-properly
  const renderFormOptions = () => options.map(({ value, icon: Icon, text }, index) => (
    <MenuItem key={index} value={value}>
      <OptionWrapper>
        {Icon &&
          <>
            <Icon />
            &nbsp;
          </>
        }
        {text}
      </OptionWrapper>
    </MenuItem>
  ))

  return (
    <InputLabel>
      {label && 
        <LabelText>
          {label}
        </LabelText>
      }
      <StyledSelect
        size='small'
        displayEmpty={displayEmpty}
        {...rest}>
        {displayEmpty &&
          <MenuItem value=''>
            <OptionWrapper>
              {emptyOptionText}
            </OptionWrapper>
          </MenuItem>
        }
        {renderFormOptions()}
      </StyledSelect>
    </InputLabel>
  )
}

const FormTextField = ({ label, labelProps={}, labelTextProps={}, textFieldProps={}, ...rest }) => {
  return (
    <InputLabel
      {...labelProps}>
      {label &&
        <LabelText {...labelTextProps}>
          {label}
        </LabelText>
      }
      <StyledTextField
        size='small'
        {...textFieldProps}
        {...rest}
      />
    </InputLabel>
  )
}

const SheerFormTextField = styled(FormTextField)`
  border-radius: 15px;

  & input {
    height: ${size(5)};
  }

  & .MuiInputBase-root {
    background-color: rgba(255,255,255,0.1);
    border-radius: 15px;
  }
`

export { FormTextField, SheerFormTextField, FormSelect, FormDivider }
